/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { Card, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";

import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { blank, getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { fetchRoleRights, updateRoleRights } from "utils/superAdminApi";

let payloadUpdate = [];
let routePath = "/roles";
function Permissions() {
  const roleId = useParams();
  const [uniqueMenuName, setUniqueMenuName] = useState([{ screenRight: "" }]);
  const [roleName, setRoleName] = useState("");
  const [planName, setPlanName] = useState("");
  const [show, setShow] = useState(false)
  const [disableColor, setDisableColor] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const [values, setValues] = React.useState({
    roleId: "",
  });

  const dispatch = useDispatch()


  useEffect(() => {
    getRight();
  }, []);

  async function getRight() {
    let right = await getScreenRight("Roles")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(false)
  }

  function setEdit() {
    setShow(true);
  }

  function setBack() {
    navigate("/roles")
    // window.location.href = '/roles';
    setShow(false);

  }
  function cancel() {
    setShow(false);
  }

  useEffect(() => {
    if (roleId.id !== undefined) {
      values.roleId = roleId.id;
      fetchRoleRightsData();
    }
  }, []);

  const fetchRoleRightsData = async () => {
    await fetchRoleRights(values, (data) => {
      setRoleName(data.Result_Output[0].roleName);
      setPlanName(data.Result_Output[0].planName);
      console.log("Permission (Role Name)", data.Result_Output)
      setUniqueMenuName(data.Result_Output);
    }, dispatch)
  };


  const handleChange1 = (name, index) => (event) => {

    if (event.target.value) {
      let newArr = [...uniqueMenuName];
      newArr[index][name] = event.target.value;
      setUniqueMenuName(newArr);
      payloadUpdate.push(newArr[index]);
    }
  };

  const roleRights = async (val) => {
    updateRoleRights(uniqueMenuName, (data) => {
      if (data.Result_Status) {
        showResMsg(genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  // const { tableBorder } = getColorMappings(sidenavColor);

  // var element = document.getElementsByTagName('fieldset');
  // for (let i = 0; i < element.length; i++) {

  //   if (darkMode) {
  //     element[i].style.borderColor = "white";
  //   } else {
  //     element[i].style.borderColor = tableBorder;
  //   }

  // }


  const { tableBorder } = getColorMappings(sidenavColor);
  useEffect(()=>{
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll('.Mui-disabled');
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    var droptext = document.querySelectorAll('.MuiInputBase-root');

     for (let i = 0; i < element.length; i++) {
        
        element[i].style.borderColor = darkMode ? "white" : tableBorder;
      } 

      for (let i = 0; i < labelShrink.length; i++) {
        labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
      }

   for (let i = 0; i < disabledval.length; i++) {
   var usevalue = disabledval[i].getElementsByTagName('input');

     if (usevalue.length > 0) {
       if (darkMode) {
         usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

       } else {
         usevalue[0].style.removeProperty("-webkit-text-fill-color");
       }
     }
   }

   for (let i = 0; i < dropicons.length; i++) {
    var svgicon = dropicons[i].getElementsByTagName('svg');
    if (svgicon.length > 0) {
      if (darkMode) {
        svgicon[0].setAttribute("style", "fill: white !important;");
      } else {
        svgicon[0].setAttribute("style", "fill:");
      }
    }
  }
     

  for (let i = 0; i < droptext.length; i++) {
    var usevaluetext = droptext[i].getElementsByTagName('div');
 
      if (usevaluetext.length > 0) {
        if (darkMode) {
          usevaluetext[0].style.setProperty("-webkit-text-fill-color", "white", "important");
 
        } else {
          usevaluetext[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }


},[uniqueMenuName])
  
  
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Height val={25} />
      <Card style={{ padding: "20px" }}>
        <MDBox
          mx={2}
          mt={-6}
          mb={1.5}
          py={2}
          px={2}
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            Permissions (Role Name: {roleName}, Plan Name: {planName})
          </MDTypography>
        </MDBox>
        {uniqueMenuName.length > 0 && uniqueMenuName[0].applicableForBusinessUser === "No" && (
          <>
            <Grid container >
              <Grid item lg={2} >
                <MDTypography type="label" color={"#1c72b2"} style={{ marginLeft: "18px" }}>
                  Super Admin
                </MDTypography>
              </Grid>
            </Grid>
            <Grid container rowSpacing={2} px={1} mb={-1}>
              {uniqueMenuName.map((val, i) => (
                <>
                  {val.userType === "Super Admin" && (
                    <>
                      <Grid item lg={4} md={2} xs={12} key={i} >
                        <FormControl fullWidth sx={{ m: 1, width: "96%", height: "100%" }}>
                          <InputLabel id="demo-simple-select-label">{val.screenName}</InputLabel>
                          <Select
                            id="demo-simple-select"
                            labelId="demo-simple-select-label"
                            value={val.screenRight}
                            style={{ height: "40px" }}
                            onChange={handleChange1("screenRight", i)}
                            label={val.screenName}
                            disabled={show === true ? false : true}
                            fullWidth
                          >
                            <MenuItem value="None">None</MenuItem>
                            <MenuItem value="Full Access">Full Access</MenuItem>
                            <MenuItem value="View Only">View Only</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </>
              ))}
            </Grid>
          </>
        )}

        {uniqueMenuName.length > 0 && uniqueMenuName[0].applicableForBusinessUser === "Yes" && (
          <>
            <Grid container>
              <MDTypography type="label" size={10} color={"#1c72b2"} style={{ marginLeft: "18px", fontWeight: "bold" }} className={darkMode ? "whiteLabel" : "blackLabel"}>
                Business User
              </MDTypography>
            </Grid>

            <Grid container rowSpacing={2} px={1.2} mb={-1}>
              {uniqueMenuName.map((val, i) => (
                <>
                  {val.userType === "Business User" && (
                    <>
                      <Grid item lg={3} md={2} xs={12} key={i} >
                        <FormControl fullWidth sx={{ m: 1, width: "96%", height: "100%" }}>
                          <InputLabel id="demo-simple-select-label">{`${val.menuName !== val.screenName ? `${val.screenName} (${val.menuName})` : val.screenName}`}</InputLabel>
                          <Select
                            id="demo-simple-select"
                            labelId="demo-simple-select-label"
                            label={`${val.menuName !== val.screenName ? `${val.screenName} (${val.menuName})` : val.screenName}`}
                            value={val.screenRight}
                            style={{ height: "40px" }}
                            onChange={handleChange1("screenRight", i)}
                            disabled={!show}

                          >
                            <MenuItem value="None">None</MenuItem>
                            <MenuItem  value="Full Access">Full Access</MenuItem>
                            <MenuItem value="View Only">View Only</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </>
              ))}
            </Grid>
          </>
        )}
      </Card>

      <Height val={15} />
      <Grid
        container
        columnSpacing={{ xs: 2, md: 4, lg: 4 }}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
        mt={0.2}
      >
        {show && <>
          <Grid item xs={12} lg={1.67} spacing={2}>

            <MDButton
              component="a"
              rel="noreferrer"
              variant="gradient"
              color="warning"
              fullWidth
              onClick={cancel}
              style={{ width: "165px", height: "40px" }}
            >
              Cancel
            </MDButton>

          </Grid>
          <Grid item xs={12} lg={1.67} spacing={2}>
            <MDButton
              component="a"
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              onClick={disableColor ? blank : roleRights}
              style={{ width: "165px", height: "40px" }}
            >
              Update
            </MDButton>
          </Grid></>
        }
        {!show &&
          <>
            <Grid item xs={12} lg={1.67} spacing={2} >
              <MDButton
                component="a"
                rel="noreferrer"
                variant="gradient"
                color="warning"
                fullWidth
                onClick={setBack}
                // style={{ background: SCREEN_RIGHT === "Full Access" ? "#5BB947" : "darkgrey" }}
                style={{ width: "165px", height: "40px" }}
              >
                Back
              </MDButton>
            </Grid>
            <Grid item xs={12} lg={1.67} spacing={2}>

              <MDButton
                component="a"
                rel="noreferrer"
                variant="gradient"
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={disableColor ? "secondary" : "success"}
                fullWidth
                onClick={disableColor ? blank : setEdit}
                style={{ width: "165px", height: "40px" }}
              >
                Edit
              </MDButton>
            </Grid>
          </>
        }
      </Grid>
    </DashboardLayout>
  );
}

export default Permissions;

